import type { loginAnnouncementsCardQuery } from 'view/login/login-announcements/__generated__/loginAnnouncementsCardQuery.graphql';
import LoginAnnouncementsCardQuery from 'view/login/login-announcements/__generated__/loginAnnouncementsCardQuery.graphql';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';

export const loginAnnouncementsCardResource = createRelayResource<loginAnnouncementsCardQuery>({
    type: 'HELP_CENTER_LOGIN_ANNOUNCEMENTS_CARD',
    getQuery: (_, { cloudId, helpCenterAri }: { cloudId: string; helpCenterAri: string }) => {
        return {
            parameters: LoginAnnouncementsCardQuery,
            variables: {
                cloudId,
                helpCenterAri,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
